import React from 'react'

export default function TracksLis({ className }) {
  return (
    <svg viewBox="0 0 25 24" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M24.179 18.598l-5.715 4.618c-.5.405-1.232.037-1.232-.619v-9.238c0-.656.732-1.024 1.232-.619l5.715 4.618c.39.315.39.924 0 1.24zm-4.21-8.785H2.019C1.202 9.813.54 9.13.54 8.287s.662-1.526 1.479-1.526h17.95c.816 0 1.479.683 1.479 1.526s-.663 1.526-1.479 1.526zm0-6.105H2.019C1.202 3.708.54 3.025.54 2.182S1.202.656 2.019.656h17.95c.816 0 1.479.683 1.479 1.526s-.663 1.526-1.479 1.526zm-17.95 9.03h11.05c.817 0 1.479.683 1.479 1.526s-.662 1.526-1.479 1.526H2.019c-.817 0-1.479-.683-1.479-1.526s.662-1.526 1.479-1.526zm0 6.105h11.05c.817 0 1.479.684 1.479 1.526 0 .843-.662 1.526-1.479 1.526H2.019c-.817 0-1.479-.683-1.479-1.526 0-.842.662-1.526 1.479-1.526z"
      />
    </svg>
  )
}
